import { observable, action, makeObservable } from 'mobx';
import Validator from 'validatorjs';
import writeReviewConfig from './WriteReviewConfig';
import { getPreview, submitReviews } from '../services/bazaarvoice-api';
import { customJsonstringify } from '../utils/helpers/customJsonstringify.helpers';

const apiconfig = require('../config');
const productionSiteUrl = require('../config/production.json').siteUrl;

class WriteReviewStore {
  previewForm = writeReviewConfig.form;

  onChange = (field, value) => {
    this.previewForm.fields[field].value = value;
  };

  validateField = field => {
    // Skip validation if field has no rule defined
    if (!this.previewForm.fields[field] || !this.previewForm.fields[field].rule) {
      return true;
    }

    let validatorObj = {};
    validatorObj = {
      required: field + 'RequiredError',
      regex: field + 'FormatError',
      between: field + 'CharactersError',
    };

    let validator = new Validator(
      { [field]: this.previewForm.fields[field].value },
      {
        [field]: JSON.parse(
          customJsonstringify(this.previewForm.fields[field].rule)
        ),
      },
      validatorObj
    );
    let isValid = validator.passes();
    let errorField = this.previewForm.fields[field].error;
    let errorFlag = this.previewForm.fields[field].errorFlag;
    if (isValid && errorFlag) {
      this.previewForm.fields[field].errorFlag = false;
      this.previewForm.fields.errorLength.value -= 1;
    } else if (!isValid && !errorField) {
      this.previewForm.fields[field].errorFlag = true;
      this.previewForm.fields.errorLength.value += 1;
    }

    this.previewForm.fields[field].error = validator.errors.first(field);

    return isValid;
  };

  onCancel = () => {
    Object.keys(this.previewForm.fields).forEach(f => {
      this.previewForm.fields[f].value = '';
    });

    // for removing the errors
    Object.keys(this.formErrors.fields).forEach(f => {
      this.formErrors.fields[f].error = '';
    });
  };

  setAgeRestriction = () => {
    const expirationDate = new Date();
    expirationDate.setTime(
      expirationDate.getTime() +
        apiconfig.ageRestrictionExpirationDays * 24 * 60 * 60 * 1000
    );
    document.cookie = `WRITE_REVIEW_AGE_RESTRICTION = WRITE_REVIEW_AGE_RESTRICTION;expires=${expirationDate.toUTCString()};path=/`;
  };

  checkUserAge = (dobMonth, dobYear) => {
    let date = new Date();
    let dateFrom = new Date(dobYear, dobMonth);
    let dateTo = new Date(date.getFullYear(), date.getMonth() + 1);
    let userAge =
      (dateTo.getMonth() - dateFrom.getMonth()) / 12 +
      (dateTo.getFullYear() - dateFrom.getFullYear());
    return userAge < 16 ? false : true;
  };

  onSubmit = () => {
    if (document.cookie.indexOf('WRITE_REVIEW_AGE_RESTRICTION') > -1) {
      this.previewForm.fields.serverErrorFlag.value = true;
      this.previewForm.fields.serverError.value = 'ageCriteriaError';
      return;
    } else if (
      !this.checkUserAge(
        this.previewForm.fields.dobMonth.value,
        this.previewForm.fields.dobYear.value
      )
    ) {
      this.previewForm.fields.serverErrorFlag.value = true;
      this.previewForm.fields.serverError.value = 'ageCriteriaError';
      this.setAgeRestriction();
      return;
    }

    let errors = [];
    let write_post_data = {};
    // AZURE DOMAIN URL'S ARE NOT ACCEPTED BY API, NEEDS TO BE CHANGED
    let callbackUrl = `${productionSiteUrl}/${this.locale.toLowerCase()}`;

    write_post_data = {
      rating: this.previewForm.fields.overallRating.value,

      isRecommended: this.previewForm.fields.recommend.value,
      reviewSummary: this.previewForm.fields.summary.value,
      reviewText: this.previewForm.fields.description.value,
      userNickname: this.previewForm.fields.nickname.value,

      contextdatavalue_Agemonth: this.previewForm.fields.dobMonth.value,
      contextdatavalue_Ageyear: this.previewForm.fields.dobYear.value,
      userEmail: this.previewForm.fields.email.value,
      agreedToTermsAndConditions: this.previewForm.fields.terms.value,
      productID: this.previewForm.fields.productID.value,
      localeVal: this.locale,
      preview: this.previewForm.fields.preview.value,
      thankyou: this.previewForm.fields.thankyou.value,
      sorryModal: this.previewForm.fields.sorryModal.value,
      isSubmit: this.previewForm.fields.isSubmit.value,
      fp: document.getElementById('ioBlackBox').value,
      hostedAuthentication_AuthenticationEmail: this.previewForm.fields.email
        .value,
      callBackURL: callbackUrl,
    };

    Object.keys(this.previewForm.fields).forEach(field => {
      if (this.previewForm.fields[field].rule) {
        if (!this.validateField(field)) {
          errors.push(false);
        }
      }
    });

    this.previewForm.fields.errorLength.value = errors.length;
    if (errors.length > 0) {
      return;
    } else if (
      errors.length === 0 &&
      this.previewForm.fields.isSubmit.value === false
    ) {
      getPreview(
        write_post_data,
        write_post_data.localeVal,
        write_post_data.productID
      )
        .then(response => {
          if (response.data.HasErrors === true) {
            const formErrors = response.data.FormErrors;
            if (formErrors.FieldErrorsOrder) {
              formErrors.FieldErrorsOrder.map(errorKey => {
                this.previewForm.fields.serverErrorFlag.value = true;
                if (errorKey === 'usernickname') {
                  this.previewForm.fields.serverError.value =
                    'nickNameCriteriaError';
                }
                if (errorKey === 'contextdatavalue_Ageyear') {
                  this.previewForm.fields.serverError.value =
                    'ageCriteriaError';
                  this.setAgeRestriction();
                }
              });
            } else {
              this.previewForm.fields.serverErrorFlag.value = true;
              this.previewForm.fields.serverError.value =
                response.data.Errors[0].Message;
            }
          } else {
            let preview = this.previewForm.fields['preview'];
            preview.value = true;
          }
        })
        .catch(err => {
          throw new Error(err);
        });
    }
    if (this.previewForm.fields.isSubmit.value === true) {
      submitReviews(
        write_post_data,
        write_post_data.localeVal,
        write_post_data.productID
      )
        .then(response => {
          if (response.status === 200 && response.data.HasErrors === false) {
            let showModal = this.previewForm.fields.thankyou;
            showModal.value = true;
          } else {
            let showModal = this.previewForm.fields.sorryModal;
            showModal.value = true;
          }
        })
        .catch(() => {
          let showModal = this.previewForm.fields.sorryModal;
          showModal.value = true;
        });
    }
  };

  constructor() {
    makeObservable(this, {
      previewForm: observable,
      onChange: action,
      onCancel: action
    });
  }
}

const productReviewstore = new WriteReviewStore();

export default productReviewstore;
